import { WebStorageStateStore } from "oidc-client";

export const azureUserManagerConfig = {
  authority: `${process.env.REACT_APP_AZURE_AUTH_URL}`,
  client_id: `${process.env.REACT_APP_AZURE_AUTH_CLIENT_ID}`,
  redirect_uri: `https://${window.location.host}/redirect`,
  silent_redirect_uri: `https://${window.location.host}/redirect`,
  response_type: "code",
  scope: `${process.env.REACT_APP_AZURE_AUTH_SCOPE}`,
  code_challenge_method: "S256",
  automaticSilentRenew: true,
  loadUserInfo: false,
  revokeAccessTokenOnSignout: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
